import { takeEvery, put } from "redux-saga/effects";
import { GA_CATEGORIES, GA_EVENTS } from "../../data/ga-constants";
import { getErrorMessage, pos_errormap_without_label } from "../../helpers/errors-helper";
import { sendGTMEvent } from "../../helpers/ga-helpers";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import { getUserDetails, saveLoginData, saveUserDetails, userLogout, validateUserData } from "../slices";
import { userNormalLogout, supportLogout } from "../actions";
import { getLoginMetaInfo, isSupportLogin } from "../../helpers/common-helper";
import { LOGIN_TYPES } from "../../data/constants";

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  code?: string;
}

function* validateUser(actions: any) {
  try {
    const metaInfo = getLoginMetaInfo({ loginType: LOGIN_TYPES.webAuthLogin });
    const dataToPost = {
      ...actions.payload.dataToPost,
      metaInfo
    }
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.LOGIN.validateUserApi,
      data: dataToPost,
    });
    if (response.code) {
      const data = {
        event_category: GA_CATEGORIES.LOGIN,
        event_label: dataToPost?.accountNumber,
        non_interaction: false,
        user_id: dataToPost?.userId,
        reason: getErrorMessage(pos_errormap_without_label, response.code),
      };
      sendGTMEvent({ eventName: GA_EVENTS.LOGIN_FAIL, data });
    }
    if (!response?.code || response?.code !== 'REST_AUTHENTICATION_FAILED') {
      yield put(saveLoginData(response));
      actions.payload.callback(true);
    } else {
      actions.payload.callback(false);
    }
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* logoutUser(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.LOGIN.logoutUserApi,
    });
    window.postMessage({ detail: { message: { ACTION: "LOGOUT_USER" } } });
    
    // Dispatch the appropriate logout action based on login type
    const isSupport = isSupportLogin();
    if (isSupport) {
      yield put(supportLogout());
    } else {
      yield put(userNormalLogout());
    }
    
    actions.payload.callback && actions.payload.callback();
  } catch (error) {
    actions.payload.callback && actions.payload.callback();
    console.log(error);
  }
}

function* fetchUserDetails(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.LOGIN.userDetailsApi(actions?.payload?.businessUserId)
    })
    if (!response?.code) {
      yield put(saveUserDetails(response))
      actions.payload?.callback && actions.payload.callback(response);
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(validateUserData.type, validateUser);
  yield takeEvery(userLogout.type, logoutUser);
  yield takeEvery(getUserDetails.type, fetchUserDetails);
}
